import * as React from 'react';
import styled from 'styled-components';

import { AquaTheme as T } from '../AquaTheme';
import { GlassPane, GlassPaneCaption } from '../GlassPane';

interface IProps {
  /** @ignore */
  className?: string;
  /** Optional caption. */
  caption?: string;
  /** Legend entries. */
  entries: { name: string, color: string }[];
}

/**
 * Map legend on a GlassPane: a caption and a list of color swatches.
 */
const AquaLegendBase = (props: IProps) =>
  <GlassPane bordered padded className={props.className}>
    {props.caption && <GlassPaneCaption>{props.caption}</GlassPaneCaption>}
    <List>
      {props.entries.map(e =>
        <Entry key={e.name}>
          <Swatch style={{ backgroundColor: e.color }}/>
          {e.name}
        </Entry>
      )}
    </List>
  </GlassPane>

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
`

const Entry = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font: ${T.font.bodySmall};
`

const Swatch = styled.div`
  width: 12px;
  height: 12px;
  flex: none;
  border-radius: 3px;
  box-shadow: inset 0 0 0 1px rgba(0,0,0,0.15);
`

const AquaLegend = styled(AquaLegendBase)`
  width: 170px;
  user-select: none;
  pointer-events: none;
`

export { AquaLegend }
